import { queryClient } from '@repo/lib/react-query';
import { useTrpc } from '@repo/lib/trpc-context';
import type { OrderAsset } from '@repo/types/order';
import { useMutation } from '@tanstack/react-query';

import { API } from './utils.api';

export const useOrderUpdateMutation = () => {
    const trpc = useTrpc();

    return useMutation(
        trpc.orderUpdate.create.mutationOptions({
            onMutate: async (_input, context) => {
                const orderRetrievalQueryKey = [API.assetDetails];

                await context.client.cancelQueries({ queryKey: orderRetrievalQueryKey });
                const previousOrderRetrieval = queryClient.getQueryData<OrderAsset>(orderRetrievalQueryKey);

                return { previousOrderRetrieval };
            },
            onError: (_error, _input, onMutateResult) => {
                if (onMutateResult?.previousOrderRetrieval) {
                    queryClient.setQueryData<OrderAsset>([API.assetDetails], onMutateResult.previousOrderRetrieval);
                }
            },
            onSettled: () => {
                void queryClient.invalidateQueries({
                    queryKey: [API.assetDetails],
                });
                void queryClient.invalidateQueries({
                    queryKey: [API.timeWindows],
                    refetchType: 'none',
                });
            },
        })
    );
};
